const data = {
    meta: {
        name: 'Contact Us'
    },

    actions: {},

    form: {
        method: 'post',
        endpoint: 'https://treadright.us5.list-manage.com/subscribe/post?u=b5ecda06f536007ec11820204&amp;id=e9fd4baaa9'
    },

    layout: `
        <div class="wrap">
            <div id="ph-FNAME"></div>
            <div id="ph-LNAME"></div>
            <div id="ph-EMAIL"></div>
            <div id="ph-MMERGE3"></div>
        </div>
        <div id="ph-accepted_privacy"></div>
        <div id="ph-controls"></div>
    `,

    controls: [
        {type: 'submit', text: 'Subscribe now'}
    ],

    fields: [
        {
            title: 'First Name *',
            key: 'FNAME',
            type: 'SmallText',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'First Name'
            }
        },
        {
            title: 'Last Name',
            key: 'LNAME',
            type: 'SmallText',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'Last Name'
            }
        },
        {
            title: 'Email Address',
            key: 'EMAIL',
            type: 'Email',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'Email Address'
            },
            errorMessage: 'We need an email address'
        },
        {
            title: 'Country',
            key: 'MMERGE3',
            type: 'SmallText',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'Country of residence'
            }
        },

        {
            name: 'gdpr[4181]',
            key: 'accepted_privacy',
            type: 'Acceptance',
            validations: {
                required: true
            },
            dict: {
                title: `I have read and accept the <a target="_blank" href="/privacy-policy/">Privacy Policy.</a>`
            },
            checked: false,
            startValue: 'Y'
        }
    ]
};

export default class ContactSchema {
    constructor() {
        this._data = data;

        return this;
    }

    get data() {
        return this._data;
    }
}